const useStyles = theme => ({
    container: {
        alignItems: "center",
        flexGrow: 1,
        display: 'flex',
        marginTop: 35,
        [theme.breakpoints.down('sm')]: {
            marginTop: 25,
        }
    },
    linksContainerMobile: {
      marginTop: 25,
    },
    linksColumnMobile: {
      width: 200,
    },
    linksContainerDesktop: {
        marginTop: 20,
        justifyContent: "space-evenly",
        [theme.breakpoints.down('sm')]: {
            justifyContent: "flex-start",
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 100,
            paddingRight: 100
        }
    },
    linksItem: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 70,
            minWidth: '30%'
        }
    },
    linkText: {
        textAlign: 'left',
        display: "-webkit-box",
        boxOrient: "vertical",
        lineClamp: 1,
        wordBreak: "break-word",
        overflow: "hidden",
    },
    separator: {
        marginTop: 30,
        marginBottom: 30,
        height: 1,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 10,
            marginRight: 10
        },
        [theme.breakpoints.only('md')]: {
            marginLeft: 50,
            marginRight: 50
        },
        [theme.breakpoints.up('lg')]: {
            marginLeft: 180,
            marginRight: 180
        }
    },
    socialLinksContainer: {
        justifyContent: 'center'
    },
    socialLinksButtonsContainer: {
        marginTop: 20,
        marginBottom: 30,
        justifyContent: 'center'
    },
    socialLinksButtonItem: {
        marginLeft: 10,
        borderRadius: 20,
    },
    socialLinksButton: {
        height: 40,
        width: 40,
    },
    poweredByContainer: {
        alignItems: "center",
        justifyContent: "center",
        height: 48,
    },
    thinSeparator: {
      width: '100%',
    },
    footerLinksTitleContainer: {
      marginTop: 28,
    }
});

export default useStyles
